import { useApiDeleteRequest } from '../hooks/useApiDeleteRequest';
import { useApiPatchRequest } from '../hooks/useApiPatchRequest';
import { useApiPostRequest } from '../hooks/useApiPostRequest';
import {
  DELETE_CUSTOM_BENCHMARK_PATH,
  DeleteCustomBenchmarkErrorDto,
  DeleteCustomBenchmarkRequestPathVariables,
  DeleteCustomBenchmarkRequestQueryParams,
  DeleteCustomBenchmarkSuccessDto,
  PATCH_CUSTOM_BENCHMARK_PATH,
  PatchCustomBenchmarkErrorDto,
  PatchCustomBenchmarkRequestBodyData,
  PatchCustomBenchmarkRequestPathVariables,
  PatchCustomBenchmarkRequestQueryParams,
  PatchCustomBenchmarkSuccessDto,
  POST_CUSTOM_BENCHMARK_PATH,
  PostCustomBenchmarkErrorDto,
  PostCustomBenchmarkRequestBodyData,
  PostCustomBenchmarkRequestPathVariables,
  PostCustomBenchmarkRequestQueryParams,
  PostCustomBenchmarkSuccessDto,
} from './types/benchmark';

export const usePostCustomBenchmark = () => {
  return useApiPostRequest<
    PostCustomBenchmarkRequestPathVariables,
    PostCustomBenchmarkRequestQueryParams,
    PostCustomBenchmarkRequestBodyData,
    PostCustomBenchmarkSuccessDto,
    PostCustomBenchmarkErrorDto
  >(POST_CUSTOM_BENCHMARK_PATH);
};

export const usePatchCustomBenchmark = () => {
  return useApiPatchRequest<
    PatchCustomBenchmarkRequestPathVariables,
    PatchCustomBenchmarkRequestQueryParams,
    PatchCustomBenchmarkRequestBodyData,
    PatchCustomBenchmarkSuccessDto,
    PatchCustomBenchmarkErrorDto
  >(PATCH_CUSTOM_BENCHMARK_PATH);
};

export const useDeleteCustomBenchmark = () => {
  return useApiDeleteRequest<
    DeleteCustomBenchmarkRequestPathVariables,
    DeleteCustomBenchmarkRequestQueryParams,
    DeleteCustomBenchmarkSuccessDto,
    DeleteCustomBenchmarkErrorDto
  >(DELETE_CUSTOM_BENCHMARK_PATH);
};
